import {useContext, useState} from "react";
import Header from "../components/header/Header.jsx";
import PageTitle from "../components/PageTitle.jsx";
import Sidebar from "../components/sidebar/Sidebar.jsx";
import Spinner from "../components/Spinner.jsx";
import {useRequireLoginEffect} from "../components/auth/useRequireLoginEffect.js";
import {GlobalContext} from "../utils/context/GlobalContextProvider.jsx";
import Sticky from "react-stickynode";
import AppAlerts from "./AppAlerts.jsx";

export default function MediumSecureLayout({title, actions, children, alerts = []}) {

    const {context} = useContext(GlobalContext);

    const [sidebarOpen, setSidebarOpen] = useState(false);

    useRequireLoginEffect();

    return (
        <div className="flex h-[100dvh] overflow-hidden">

            {/* Sidebar */}
            <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen}/>

            {/* Content area */}
            <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">

                {/*  Site header */}
                <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen}/>

                <main className="layout-medium grow px-4 sm:px-6 lg:px-8">
                    <AppAlerts alerts={alerts} />

                    <div className="pt-2 sm:pt-4 md:pt-6 pb-8 w-full max-w-screen-lg mx-auto">
                        <div className="mx-auto">

                            {(title || actions) &&
                                <Sticky>
                                    <div
                                        className={'mb-3 text-center sm:text-left sm:flex justify-between mb-4 sm:mb-6 md:mb-8'}
                                    >
                                        {title &&
                                            <PageTitle>{title}</PageTitle>
                                        }
                                        {actions &&
                                            <div className={'my-auto'}>{actions ?? null}</div>
                                        }
                                    </div>
                                </Sticky>
                            }

                                <div>
                                    {context.currentIdentity === null ? <Spinner/> : children}
                                </div>
                            </div>
                        </div>
                </main>
            </div>
        </div>
    );
}
